class LocalStorage {
  // Set the json data to local
  setItem(key, value) {
    window.localStorage.setItem(key, value);
  }

  // Set the json data to local
  setObject(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  // Get the json value from local
  getItem(key) {
    return window.localStorage.getItem(key);
  }

  // Get the json value from local
  getObject(key) {
    const item = window.localStorage.getItem(key)
    return item ? JSON.parse(item) : null;
  }

  // Get the json value from local
  removeItem(key) {
    return window.localStorage.removeItem(key);
  }

  // Clear the local
  clear() {
    return window.localStorage.clear();
  }
}

export default new LocalStorage();



// WEBPACK FOOTER //
// ./src/services/localStorage.service.js